<brisk-jsfc #jsfcComponent [jsfcEntries]="jsfcEntries | async" [minWidth]="720"> </brisk-jsfc>
